/**
 * @generated SignedSource<<7f35653e95faece3787d249fc2f65bbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsCarousel_viewer$data = {
  readonly visuallySimilarItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_items">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_viewer">;
  readonly " $fragmentType": "PdpRespSimilarItemsCarousel_viewer";
};
export type PdpRespSimilarItemsCarousel_viewer$key = {
  readonly " $data"?: PdpRespSimilarItemsCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchVisuallySimilar"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./PdpRespSimilarItemsCarouselRefetchQuery.graphql')
    }
  },
  "name": "PdpRespSimilarItemsCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_viewer"
    },
    {
      "condition": "fetchVisuallySimilar",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "visuallySimilarItems",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            },
            {
              "kind": "Variable",
              "name": "itemPk",
              "variableName": "itemId"
            }
          ],
          "concreteType": "VisualSearchConnection",
          "kind": "LinkedField",
          "name": "visualSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VisualSearchEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "priceBookName",
                          "variableName": "priceBookName"
                        },
                        {
                          "kind": "Variable",
                          "name": "userCountryCode",
                          "variableName": "userCountryCode"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "PdpRespProductTileCarousel_items"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e8504fe853b439a04172f3a60c69aea4";

export default node;
